var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle116(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "114.9600586135427 144.7259289661098 16.454549319937186 17.33139690003989",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M123.36,148.73c3.24.13,5.1,3.51,3.43,6.3-.37.62-.88,1.15-1.35,1.7-1.45,1.67-3.31,1.78-4.85.24-1.32-1.32-1.83-2.95-1.56-4.78.32-2.14,2.13-3.55,4.33-3.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle116);
export default __webpack_public_path__ + "static/media/twinkle-1-16.92fbee258a41d10d2ffca4065c20d198.svg";
export { ForwardRef as ReactComponent };